export default __webpack_public_path__ + "static/media/logo_1.8f084f0b.png";